__turbopack_context__.v({
  "coding-exercise-modal-container": "coding-exercise-promotion-modal-module-scss-module__QkMULa__coding-exercise-modal-container",
  "coding-exercise-modal-trigger": "coding-exercise-promotion-modal-module-scss-module__QkMULa__coding-exercise-modal-trigger",
  "demo-intro": "coding-exercise-promotion-modal-module-scss-module__QkMULa__demo-intro",
  "video-container": "coding-exercise-promotion-modal-module-scss-module__QkMULa__video-container",
});
